import { SnackbarProvider } from 'notistack';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './Hooks/usePreventScrolling';
import './App.css'

// Agency Dashboard pages
import AgencyMainLayout from './Panels/Agency/MainLayout/MainLayout';
import AgencyDashboard from './Panels/Agency/Pages/Activity/Dashboard/Dashboard';
import AgencyWorkspace from './Panels/Agency/Pages/Activity/Workspace/Workspace';
import AgencyTickets from './Panels/Agency/Pages/Activity/Tickets/Tickets';
import AgencyAddTicket from './Panels/Agency/Pages/Activity/Tickets/AddTicketPage/AddTicket';
import AgencyOrders from './Panels/Agency/Pages/Activity/Orders/Orders';
import AgencyClients from './Panels/Agency/Pages/Activity/Clients/Clients';
import AgencyServices from './Panels/Agency/Pages/Setup/Services/Services';
import AgencyTeam from './Panels/Agency/Pages/Setup/Team/Team';
import AgencyViewTicket from './Panels/Agency/Pages/Activity/Tickets/ViewTicketPage/ViewTicketPage';
import AgencyViewOrder from './Panels/Agency/Pages/Activity/Orders/ViewOrderPage/ViewOrderPage';
import AgencyAddOrder from './Panels/Agency/Pages/Activity/Orders/AddOrderPage/AddOrder';
import AgencyAddClient from './Panels/Agency/Pages/Activity/Clients/AddClientPage/AddClient';
import AgencyViewClient from './Panels/Agency/Pages/Activity/Clients/ViewClientPage/ViewClientPage';
import AgencyInvoices from './Panels/Agency/Pages/Billing/Invoices/Invoices';
import AgencySubscriptions from './Panels/Agency/Pages/Billing/Subscriptions/Subscriptions';
import AgencyAddInvoice from './Panels/Agency/Pages/Billing/Invoices/AddInvoicePage/AddInvoice';
import AgencyViewInvoicePage from './Panels/Agency/Pages/Billing/Invoices/ViewInvoicePage/ViewInvoicePage';
import AgencyAddSubscription from './Panels/Agency/Pages/Billing/Subscriptions/AddSubscriptionPage/AddSubscription';
import AgencyViewSubscriptionPage from './Panels/Agency/Pages/Billing/Subscriptions/ViewSubscriptionPage/ViewSubscriptionPage';
import AgencyAddService from './Panels/Agency/Pages/Setup/Services/AddServicePage/AddService';
import AgencyUpgrades from './Panels/Agency/Pages/MoreFeatures/Upgrades/Upgrades';
import AgencyIntegrations from './Panels/Agency/Pages/Setup/Integrations/Integrations';
import AgencyStripeIntegrationPage from './Panels/Agency/Pages/Setup/Integrations/IntegrationPages/StripeIntegrationPage';
import AgencySlackIntegrationPage from './Panels/Agency/Pages/Setup/Integrations/IntegrationPages/SlackIntegrationPage';
import AgencyGmailIntegrationPage from './Panels/Agency/Pages/Setup/Integrations/IntegrationPages/GmailIntegrationPage';
import AgencySettings from './Panels/Agency/Pages/Setup/Settings/Settings';
import AgencyForms from './Panels/Agency/Pages/Setup/Forms/Forms';
import AgencyAddFormPage from './Panels/Agency/Pages/Setup/Forms/AddFormPage/AddFormPage';

// Client Dashboard pages
import ClientMainLayout from './Panels/Client/MainLayout/MainLayout';
import ClientDashboard from './Panels/Client/Pages/Activity/Dashboard/Dashboard';
import ClientTickets from './Panels/Client/Pages/Activity/Tickets/Tickets';
import ClientAddTicket from './Panels/Client/Pages/Activity/Tickets/AddTicketPage/AddTicket';
import ClientViewTicket from './Panels/Client/Pages/Activity/Tickets/ViewTicketPage/ViewTicketPage';
import ClientOrders from './Panels/Client/Pages/Activity/Orders/Orders';
import ClientViewOrder from './Panels/Client/Pages/Activity/Orders/ViewOrderPage/ViewOrderPage';
import ClientServices from './Panels/Client/Pages/Services/Services/Services';
import ClientInvoices from './Panels/Client/Pages/Billing/Invoices/Invoices';
import ClientViewInvoicePage from './Panels/Client/Pages/Billing/Invoices/ViewInvoicePage/ViewInvoicePage';
import ClientSubscriptions from './Panels/Client/Pages/Billing/Subscriptions/Subscriptions';
import ClientViewSubscriptionPage from './Panels/Client/Pages/Billing/Subscriptions/ViewSubscriptionPage/ViewSubscriptionPage';
import ClientSettings from './Panels/Client/Pages/More/Settings/Settings';
import ClientProjectDetail from './Panels/Client/Pages/Services/Services/ProjectDetail/ProjectDetail';

import Home from './MainWebsite/Pages/Home/Home';
import Footer from './MainWebsite/GlobalComp/Footer/Footer';
import Signup from './MainWebsite/Pages/Signup/Signup';
import Auth from './MainWebsite/Pages/Auth/Auth';

const AgencyRenderRouterWithSideBar = (Component, props) => (
  <AgencyMainLayout {...props} component={<Component {...props} />} />
);

const AgencyLoggedInRoutes = ({ showAgencyRoutes, setShowAgencyRoutes }) => (
  <Routes>
    <Route
      path="/"
      element={AgencyRenderRouterWithSideBar(AgencyDashboard, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/workspace"
      element={AgencyRenderRouterWithSideBar(AgencyWorkspace, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/tickets"
      element={AgencyRenderRouterWithSideBar(AgencyTickets, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-ticket"
      element={AgencyRenderRouterWithSideBar(AgencyAddTicket, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/view-ticket/:id"
      element={AgencyRenderRouterWithSideBar(AgencyViewTicket, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/orders"
      element={AgencyRenderRouterWithSideBar(AgencyOrders, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-order"
      element={AgencyRenderRouterWithSideBar(AgencyAddOrder, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/view-order/:id"
      element={AgencyRenderRouterWithSideBar(AgencyViewOrder, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/clients"
      element={AgencyRenderRouterWithSideBar(AgencyClients, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/view-client/:id"
      element={AgencyRenderRouterWithSideBar(AgencyViewClient, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-client"
      element={AgencyRenderRouterWithSideBar(AgencyAddClient, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/invoices"
      element={AgencyRenderRouterWithSideBar(AgencyInvoices, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-invoice"
      element={AgencyRenderRouterWithSideBar(AgencyAddInvoice, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/view-invoice/:id"
      element={AgencyRenderRouterWithSideBar(AgencyViewInvoicePage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/subscriptions"
      element={AgencyRenderRouterWithSideBar(AgencySubscriptions, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-subscription"
      element={AgencyRenderRouterWithSideBar(AgencyAddSubscription, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/view-subscription/:id"
      element={AgencyRenderRouterWithSideBar(AgencyViewSubscriptionPage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/services"
      element={AgencyRenderRouterWithSideBar(AgencyServices, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-service"
      element={AgencyRenderRouterWithSideBar(AgencyAddService, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/integrations"
      element={AgencyRenderRouterWithSideBar(AgencyIntegrations, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/integrations/stripe"
      element={AgencyRenderRouterWithSideBar(AgencyStripeIntegrationPage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/integrations/slack"
      element={AgencyRenderRouterWithSideBar(AgencySlackIntegrationPage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/integrations/gmail"
      element={AgencyRenderRouterWithSideBar(AgencyGmailIntegrationPage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/team"
      element={AgencyRenderRouterWithSideBar(AgencyTeam, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/settings"
      element={AgencyRenderRouterWithSideBar(AgencySettings, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/forms"
      element={AgencyRenderRouterWithSideBar(AgencyForms, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/add-intake-form"
      element={AgencyRenderRouterWithSideBar(AgencyAddFormPage, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="/upgrade"
      element={AgencyRenderRouterWithSideBar(AgencyUpgrades, { showAgencyRoutes, setShowAgencyRoutes })}
    />
    <Route
      path="*"
      element={AgencyRenderRouterWithSideBar(AgencyDashboard, { showAgencyRoutes, setShowAgencyRoutes })}
    />

    <Route path="/home" element={RenderRouterWithMenuFooter(Home)} />
    <Route path="/signup" element={<Signup />} />
    <Route path="/login" element={<Auth />} />
  </Routes>
);

const ClientRenderRouterWithSideBar = (Component, props) => (
  <ClientMainLayout {...props} component={<Component {...props} />} />
);

const ClientLoggedInRoutes = ({ showAgencyRoutes, setShowAgencyRoutes }) => (
  <>
    <Routes>
      <Route path="/"
        element={ClientRenderRouterWithSideBar(ClientDashboard, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/tickets"
        element={ClientRenderRouterWithSideBar(ClientTickets, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/add-ticket"
        element={ClientRenderRouterWithSideBar(ClientAddTicket, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/view-ticket/:id"
        element={ClientRenderRouterWithSideBar(ClientViewTicket, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/orders"
        element={ClientRenderRouterWithSideBar(ClientOrders, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/view-order/:id"
        element={ClientRenderRouterWithSideBar(ClientViewOrder, { showAgencyRoutes, setShowAgencyRoutes })}
      />

      <Route path="/services"
        element={ClientRenderRouterWithSideBar(ClientServices, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/project-details"
        element={ClientRenderRouterWithSideBar(ClientProjectDetail, { showAgencyRoutes, setShowAgencyRoutes })}
      />

      <Route path="/invoices"
        element={ClientRenderRouterWithSideBar(ClientInvoices, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/view-invoice/:id"
        element={ClientRenderRouterWithSideBar(ClientViewInvoicePage, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/subscriptions"
        element={ClientRenderRouterWithSideBar(ClientSubscriptions, { showAgencyRoutes, setShowAgencyRoutes })}
      />
      <Route path="/view-subscription/:id"
        element={ClientRenderRouterWithSideBar(ClientViewSubscriptionPage, { showAgencyRoutes, setShowAgencyRoutes })}
      />

      <Route path="/settings"
        element={ClientRenderRouterWithSideBar(ClientSettings, { showAgencyRoutes, setShowAgencyRoutes })}
      />

      <Route path='/home'
        element={RenderRouterWithMenuFooter(Home)}
      />
      <Route path='/signup' element={<Signup />} />
      <Route path='/login' element={<Auth />} />

      <Route path="*"
        element={ClientRenderRouterWithSideBar(ClientDashboard, { showAgencyRoutes, setShowAgencyRoutes })}
      />
    </Routes>
  </>
);

const RenderRouterWithMenuFooter = (Component) => (
  <>
    <Component />
  </>
);

const MainWebsiteLoggedOutRoutes = () => (
  <>
    <Routes>
      <Route path='/' element={RenderRouterWithMenuFooter(Home)} ></Route>
      <Route path='/signup' element={<Signup />} />
      <Route path='/login' element={<Auth />} />
      <Route path='*' element={RenderRouterWithMenuFooter(Home)} ></Route>
    </Routes>
  </>
)

function AppRoutes() {
  const [showAgencyRoutes, setShowAgencyRoutes] = useState(
    () => JSON.parse(localStorage.getItem("showAgencyRoutes")) ?? true
  );

  useEffect(() => {
    localStorage.setItem("showAgencyRoutes", JSON.stringify(showAgencyRoutes));
  }, [showAgencyRoutes]);

  return (
    <>
      <BrowserRouter>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <ScrollToTop />
            {showAgencyRoutes ? <AgencyLoggedInRoutes showAgencyRoutes={showAgencyRoutes} setShowAgencyRoutes={setShowAgencyRoutes} />
              : <ClientLoggedInRoutes showAgencyRoutes={showAgencyRoutes} setShowAgencyRoutes={setShowAgencyRoutes} />}
            {/* <MainWebsiteLoggedOutRoutes /> */}
        </SnackbarProvider>
      </BrowserRouter>
    </>
  );
}

export default AppRoutes;
